export default "__VITE_ASSET__93c39f9d__"